import styled from 'styled-components'

import { Box, BoxProps } from '../Box'
import { Button } from '../Button'
import { Text, Title } from '../Text'
import { Color } from '../theme'

type PromoBoxVariant = 'primaryDark' | 'gray'

const titleColors: Record<PromoBoxVariant, Color> = {
  gray: 'primaryDark',
  primaryDark: 'textPrimaryInverse'
}

const textColors: Record<PromoBoxVariant, Color> = {
  gray: 'textPrimary',
  primaryDark: 'textPrimaryInverse'
}

const bgColors: Record<PromoBoxVariant, Color> = {
  gray: 'bgPrimary',
  primaryDark: 'primaryDark'
}

const buttonType: Record<PromoBoxVariant, 'primary' | 'secondary'> = {
  gray: 'primary',
  primaryDark: 'secondary'
}

export interface PromoBoxProps extends BoxProps {
  variant: PromoBoxVariant
  title?: string
  text?: string
  buttonText?: string
  buttonClick?: () => void
}

const PromoBoxContainer = styled(Box)<PromoBoxProps>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: ${({ theme, variant }) => theme.colors[bgColors[variant]]};
  padding: ${({ theme }) => theme.space[3]};

  border-radius: 4px;
`

const StyledTitle = styled(Title)`
  padding-bottom: ${({ theme }) => theme.space[3]};
`

export const PromoBox = ({ variant, title, text, buttonText, buttonClick, ...rest }: PromoBoxProps) => {
  return (
    <PromoBoxContainer variant={variant} {...rest}>
      {title && (
        <StyledTitle level="extraLarge" color={titleColors[variant]}>
          {title}
        </StyledTitle>
      )}
      {text && (
        <Text pb={3} color={textColors[variant]}>
          {text}
        </Text>
      )}
      <div>
        <Button size="large" variant={buttonType[variant]} onClick={buttonClick}>
          {buttonText}
        </Button>
      </div>
    </PromoBoxContainer>
  )
}
